import { Component, Input } from '@angular/core';
import {
    WaterMarkWarningFormat,
    bulkWatermarkEdit,
    isWatermarkChangeIntentionalMessage,
    singleWatermarkEdit,
    watermarkInfoMessage
} from './watermark-warning-constants';

@Component({
    selector: 'cdp-watermark-change-warning-chip',
    templateUrl: './watermark-change-warning-chip.component.html',
    standalone: false
})
export class WatermarkChangeWarningChipComponent {
    @Input() editFormat: WaterMarkWarningFormat;

    checkIfIntentionalMessage = isWatermarkChangeIntentionalMessage;

    get isBulkEdit(): boolean {
        return this.editFormat === 'bulk';
    }

    get message(): string {
        return this.isBulkEdit ? bulkWatermarkEdit : singleWatermarkEdit;
    }

    get infoMessage(): string {
        return watermarkInfoMessage;
    }
}
